<div *ngIf="canCreatePage">
  <button (click)="openCreatePageDialog()" nbButton status="primary">{{ 'Create Page' | translate }}</button>
</div>
